import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import auth from "./auth";
import toolbar from "./toolbar";
import suggestion from "./suggest";
import releaseInfo from "./release";
import selectTrack from "./tracks";

const reducers = (history: any) =>
  combineReducers({
    router: connectRouter(history),
    auth,
    toolbar,
    suggestion,
    releaseInfo,
    selectTrack
  });
export default reducers;
